import { render, staticRenderFns } from "./BackOffice.vue?vue&type=template&id=35c923de"
import script from "./BackOffice.vue?vue&type=script&lang=js"
export * from "./BackOffice.vue?vue&type=script&lang=js"
import style0 from "./BackOffice.vue?vue&type=style&index=0&id=35c923de&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports